<template>
  <div class="result-wrap">
    <div class="result-top">
      <img class="result-title" src="@/assets/img/result-title.png" />
      <div class="result-desc">{{ tip }}</div>
      <img
        v-if="Number(score) > 3"
        class="result-img"
        src="@/assets/img/result-icon.png"
        alt="结果奖杯icon"
      />
      <img
        v-else
        class="result-img"
        src="@/assets/img/result-icon-grey.png"
        alt="结果奖杯icon"
      />
      <div class="result-divider"></div>
      <van-row
        class="score-items"
        type="flex"
        justify="center"
        align="center"
        gutter="50"
      >
        <van-col span="8">
          <div class="score-msg">{{ score }}/{{ totalScore }}</div>
          <div class="score-label">答对</div>
        </van-col>
        <van-col span="8">
          <div class="score-msg">{{ score }}</div>
          <div class="score-label">得分</div>
        </van-col>
        <van-col span="8">
          <div class="score-msg">{{ duration }}</div>
          <div class="score-label">时间</div>
        </van-col>
      </van-row>
    </div>
    <van-row class="btns" type="flex" gutter="8">
      <van-col span="12">
        <!-- <div class="half-btn" @click="$router.replace('/question')">
          <img src="@/assets/img/test-btn.png" />
        </div> -->
        <div class="btn-outer" @click="$router.replace('/question')">
          <div class="btn-inner" style="background-color: #00b0ff">
            继续答题
          </div>
        </div>
      </van-col>
      <van-col span="12">
        <!-- <div class="half-btn" @click="shareResult">
          <img src="@/assets/img/share-btn.png" />
        </div> -->
        <div class="btn-outer" @click="shareResult">
          <div class="btn-inner" style="background-color: #6299ff">
            炫耀成绩
          </div>
        </div>
      </van-col>
      <van-col span="24">
        <!-- <div class="full-btn" @click="goErrors">
          <img src="@/assets/img/analysis-btn.png" />
        </div> -->
        <div class="btn-outer" @click="goErrors">
          <div class="btn-inner" style="background-color: #0e2e79">
            查看题目解析
          </div>
        </div>
      </van-col>
      <van-col span="24">
        <div class="btn-outer" @click="$router.replace('/')">
          <div class="btn-inner" style="background-color: #0e2e79">返回</div>
        </div>
      </van-col>
    </van-row>
    <van-dialog
      v-model="showPrizePopup"
      class="draw-dialog"
      title=""
      :close-on-click-overlay="true"
      :show-confirm-button="false"
    >
      <div class="draw-dialog_content">
        <div class="draw-label">恭喜您！</div>
        <div class="draw-info">答对{{ score }}题，获得1次抽奖机会</div>
        <div class="draw-btn" @click="doDraw"></div>
      </div>
    </van-dialog>
    <van-dialog
      v-model="redPackDialog"
      class="custom-dialog"
      title="恭喜抽中红包"
    >
      <div class="custom-dialog_content">
        <div class="red-pack">
          <img
            class="red-pack-img"
            src="@/assets/img/red-pack.png"
            alt="红包"
          />
        </div>
        <div>
          说明：中奖红包已通过消息通知发送给您，请及时前往微信聊天中领取
        </div>
      </div>
    </van-dialog>
    <van-dialog
      v-model="missDialog"
      class="custom-dialog"
      title="很遗憾，未中奖"
    >
      <div class="custom-dialog_content">
        <div class="miss-draw">
          <img src="@/assets/img/no-reward.png" alt="未中奖" />
        </div>
      </div>
    </van-dialog>
    <van-dialog
      v-model="shareDialog"
      class="share-dialog"
      title=""
      :show-confirm-button="false"
      :close-on-click-overlay="true"
    >
      <div class="dialog_content">
        <div>
          <img
            style="width: 100%; height: 100%; vertical-align: middle"
            id="cerImg"
            :src="imgSrc"
          />
        </div>
        <img
          class="close-btn"
          src="@/assets/img/close-btn.png"
          @click="shareDialog = false"
        />
      </div>
    </van-dialog>
    <div id="shareImg">
      <div style="text-align: center">
        <div class="share-top">
          <img v-if="Number(score) > 3" src="@/assets/img/result-icon.png" />
          <img v-else src="@/assets/img/result-icon-grey.png" />
          <div class="top-label">您的朋友在</div>
          <div class="top-area">
            《2025年山西省公众科学素质网络知识竞赛》<br />获得
          </div>
          <div class="top-score">
            “{{ Number(score) === 5 ? "满分" : score
            }}<span v-if="Number(score) !== 5" class="score-measure">分</span>”
          </div>
          <div class="top-time">
            本次答题用时：{{ duration | durationFormat }}
          </div>
        </div>
        <div class="share-divider">
          <img src="@/assets/img/card-divider.png" />
        </div>
        <div class="qr-code">
          <img src="@/assets/img/qr-code.png" />
          <div>使用微信扫描识别二维码即刻参与答题</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import html2canvas from "html2canvas";
export default {
  data() {
    return {
      loading: false,
      score: 0,
      totalScore: 5,
      duration: 0,
      // 抽奖弹出层
      showPrizePopup: false,
      // 抽中红包弹窗
      redPackDialog: false,
      // 未抽中弹窗
      missDialog: false,
      shareDialog: false,
      imgSrc: "",
    };
  },
  computed: {
    type() {
      return Number(this.$route.query.type);
    },
    tip() {
      switch (Number(this.score)) {
        case 0:
          return "失败乃成功之母，加油！";
        case 1:
          return "您已迈出成功的第一步，继续突破吧！";
        case 2:
          return "您已迈出成功的第一步，继续突破吧！";
        case 3:
          return "胜利在望，加油！";
        case 4:
          return "胜利在望，加油！";
        case 5:
          return "优秀如你，再接再厉！";
        default:
          return "优秀如你，再接再厉！";
      }
    },
  },
  methods: {
    async doDraw() {
      // try {
      //   const res = await this.$axios.post(`/Redpackets/lotteryDraw`);
      //   this.showPrizePopup = false;
      //   if (res.data.money) {
      //     this.redPackDialog = true;
      //   } else {
      //     this.missDialog = true;
      //   }
      //   console.log(res);
      // } catch (error) {
      //   this.missDialog = true;
      //   console.log(error);
      // }
      this.$router.replace(
        `/draw?score=${this.score}&duration=${this.duration}`
      );
    },
    /**
     * 获取答题结果
     */
    async getResult() {
      try {
        this.$toast.loading({
          message: "获取结果中...",
          forbidClick: true,
        });
        this.loading = true;
        const res = await this.$axios.post(`/Question/getGrade`, {
          id: this.$store.state.user.id,
          sign: this.$route.query.sign,
        });
        this.loading = false;
        const { score, duration, total } = res.data;
        this.score = score;
        this.duration = duration;
        this.totalScore = total ?? 5;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: error.errorMsg || "获取结果失败！",
          duration: 2000,
        });
        console.log(error);
      } finally {
        this.$toast.clear();
      }
    },
    async hasDrawChance() {
      try {
        // if (Number(this.score) > 3) {
        const res = await this.$axios.post(`/Redpackets/getLotteryNum`);
        if (res.data.success) {
          this.showPrizePopup = true;
        }
        // }
      } catch (error) {
        console.log(error);
      }
    },
    // 炫耀成绩
    shareResult() {
      setTimeout(() => {
        this.$nextTick(() => {
          html2canvas(document.querySelector("#shareImg"), {
            dpi: 96, // 分辨率
            scale: 1, // 设置缩放
            useCORS: true,
            bgcolor: "#ffff", // 应该这样写
            logging: false, // 打印日志用的 可以不加默认为false
          })
            .then((canvas) => {
              return new Promise((resolve) => {
                canvas.toBlob((blob) => resolve(blob));
              });
            })
            .then((blob) => {
              const fr = new FileReader();
              fr.readAsDataURL(blob);
              fr.onload = (e) => {
                this.imgSrc = e.target.result;
              };
              // const url = URL.createObjectURL(blob);
              // this.imgSrc = url;
              this.shareDialog = true;
            });
        });
      }, 100);
    },
    goErrors() {
      this.$router.replace(
        `/errors?type=2&score=${this.score}&duration=${this.duration}`
      );
    },
  },
  created() {
    if (Number(this.$route.query.type) === 2) {
      this.score = this.$route.query.score;
      this.duration = this.$route.query.duration;
    } else {
      this.getResult().then(() => {
        this.hasDrawChance();
      });
    }
  },
};
</script>
<style lang="scss" scoped>
.result-wrap {
  position: relative;
  padding: 50px 20px 0;
  @include content-bg;
  .draw-dialog {
    width: 228px;
    background-color: transparent;
    .draw-dialog_content {
      position: relative;
      width: 100%;
      height: 323px;
      text-align: center;
      background: url("~@/assets/img/draw-icon.png") no-repeat top center/100%;
      .draw-label {
        padding-top: 103px;
        font-size: 20px;
        font-weight: 600;
        line-height: 25px;
        color: #ef1c00;
      }
      .draw-info {
        margin-top: 3px;
        font-size: 14px;
        line-height: 25px;
        color: #ef1c00;
      }
      .draw-btn {
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 40px;
      }
    }
  }
  .custom-dialog_content {
    .red-pack {
      .red-pack-img {
        width: 48px;
        height: 59px;
        transform: rotate(15deg);
        animation: shake 1s linear infinite;
      }
      @keyframes shake {
        0% {
          transform: rotate(0deg);
        }
        10% {
          transform: rotate(-15deg);
        }
        20% {
          transform: rotate(0deg);
        }
        30% {
          transform: rotate(15deg);
        }
        40% {
          transform: rotate(0deg);
        }
        50% {
          transform: rotate(-15deg);
        }
        60% {
          transform: rotate(0deg);
        }
        70% {
          transform: rotate(15deg);
        }
        80% {
          transform: rotate(0deg);
        }
        90% {
          transform: rotate(-15deg);
        }
        100% {
          transform: rotate(0deg);
        }
      }
    }
    .miss-draw {
      img {
        width: 114px;
        height: 100px;
      }
    }
  }
  .result-top {
    padding: 35px 12px 20px;
    text-align: center;
    background: #fff;
    border: 2px solid #000;
    border-radius: 6px;
    .result-title {
      width: 114px;
      height: 27px;
    }
    .result-desc {
      margin-top: 12px;
      font-size: 17px;
      font-weight: 400;
      color: #4581fc;
    }
    .result-img {
      width: 199px;
      height: 185px;
      margin-top: 12px;
    }
    .result-divider {
      margin-top: 12px;
      border-bottom: 2px dotted #e5e5e5;
    }
    .score-items {
      padding: 15px 20px 0;
      .score-msg {
        font-size: 21px;
        line-height: 36px;
        color: #ff2609;
      }
      .score-label {
        font-size: 18px;
        line-height: 36px;
        color: #000;
      }
    }
  }
  .btns {
    padding: 10px 20px 0;
    .half-btn {
      width: 143px;
      height: 37px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .full-btn {
      width: 295px;
      height: 37px;
      margin-top: 13px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .share-dialog {
    width: 90%;
    overflow: visible;
    border-radius: 0;
    .dialog_content {
      position: relative;
      .close-btn {
        position: absolute;
        top: calc(100% + 10px);
        left: calc(50% - 15px);
        width: 30px;
        height: 30px;
        cursor: pointer;
      }
    }
  }
  .btn-outer {
    height: 34px;
    margin-top: 13px;
    background: #fff;
    border: 1px solid #333;
    border-radius: 30px;
    .btn-inner {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 30px;
      font-size: 17px;
      font-weight: 500;
      color: #fff;
      background: #07c160;
      border-bottom: 1px solid #333;
      border-radius: 30px;
    }
  }
  #shareImg {
    position: absolute;
    left: 99999px;
    width: 566px;
    padding: 96px 34px 40px;
    background: url("~@/assets/img/plain-bg.png") no-repeat top center/100%;

    .share-top {
      background: #fff;
      border-radius: 18px 18px 0 0;

      img {
        width: 274px;
        height: 264px;
      }

      .top-label {
        margin-top: 26px;
        font-size: 34px;
        font-weight: 600;
        line-height: 38px;
        color: #333;
      }

      .top-area {
        margin-top: 8px;
        font-size: 25px;
        line-height: 28px;
        color: #333;
      }

      .top-score {
        margin-top: 24px;
        font-size: 64px;
        font-weight: 600;
        line-height: 76px;
        color: #46a87d;

        .score-measure {
          font-size: 28px;
          font-weight: 400;
          line-height: 32px;
          color: #46a87d;
        }
      }

      .top-time {
        padding: 24px 0 50px;
        font-size: 25px;
        font-weight: 400;
        line-height: 28px;
        color: #46a87d;
      }
    }

    .share-divider {
      margin: -1px 0 -9px;

      img {
        width: 566px;
      }
    }

    .qr-code {
      background: #ffff;
      border-radius: 0 0 18px 18px;

      img {
        width: 150px;
        height: 150px;
      }

      div {
        padding: 20px 0 14px;
        font-size: 20px;
        line-height: 24px;
        color: #333;
      }
    }
  }
}
</style>
